import { computed, inject, Injectable, Signal } from '@angular/core';
import { CatalogueService } from '@catalogue';
import { applianceContent } from '../../constants/appliance-content.constant';
import { Appliance } from '../../models/appliance-content.interface';

@Injectable({
  providedIn: 'root',
})
export class SinglePlanService {
  private readonly catalogueService = inject(CatalogueService);
  private readonly applianceContent = applianceContent;

  readonly selectedApplianceCode: Signal<string | undefined> = computed(
    () => this.catalogueService.steppedFormAppliance()?.applianceCode,
  );

  readonly selectedApplianceContent: Signal<Appliance> = computed(() => {
    const code = this.selectedApplianceCode();

    return (
      this.applianceContent.find(
        (appliance: Appliance) => appliance.applianceCode === code,
      ) ?? applianceContent[0]
    );
  });
}
